<template>
    <ChangeSecretQuestions></ChangeSecretQuestions>
</template>

<script>
import ChangeSecretQuestions from '@components/ChangeSecretQuestions';

export default {
    components: {
        ChangeSecretQuestions
    }
};
</script>
